import { WaveSurferParams } from 'wavesurfer.js/types/params';

import regions from 'wavesurfer.js/src/plugin/regions';
import markers from 'wavesurfer.js/src/plugin/markers';
import timeline from 'wavesurfer.js/src/plugin/timeline';
import cursor from 'wavesurfer.js/src/plugin/cursor';

export const WS_PARAMS: Partial<WaveSurferParams> = {
  backend: 'WebAudio',
  scrollParent: false,
  barWidth: 2,
  progressColor: '#4f82f7',
  interact: false,
  barHeight: 1,
  plugins: [
    regions.create({}),
    markers.create({
      markers: [],
    }),
    timeline.create({ container: '#timeline' }),
    cursor.create({ showTime: false, opacity: '1' }),
  ],
};
